import Component from '@glimmer/component';
import { action } from '@ember/object';
import PS from 'mewe/utils/pubsub';
import { isDefined } from 'mewe/utils/miscellaneous-utils';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';

export default class MwEmojiButton extends Component {
  @service dynamicPopups;

  @tracked element;

  @action
  onInsert(element) {
    this.element = element;
  }

  @action
  setEmoji(emoji) {
    // case for emoji preset in postbox
    if (isDefined(this.args.emojis) && this.args.emojis.length < 4 && !this.args.emojis.includes(emoji)) {
      this.args.addEmoji(emoji);
      return;
    }

    // in text-editor
    if (typeof this.args.onEmojiSelect === 'function') {
      this.args.onEmojiSelect(emoji);
      return;
    }

    this.args.setPicker?.(false);
  }

  @action
  mouseDown() {
    // needed for properly closing another popups
    PS.Pub('close.dropdowns');
    return false;
  }

  @action
  emojiPickerAfterClose() {
    if (this.isDestroyed || this.isDestroying) return;
    this.args.setPicker?.(false);
  }

  @action
  click() {
    if (typeof this.args.popupDidOpen === 'function') this.args.popupDidOpen();
    this.args.setPicker?.(true);

    this.dynamicPopups.openPopup('mw-emoji-picker', {
      parent: this.element,
      setEmoji: this.setEmoji,
      onClose: this.emojiPickerAfterClose,
      beforeStoreRedirection: this.args.beforeStoreRedirection,
    });
  }
}
